/* eslint-disable @typescript-eslint/ban-ts-comment */

import type { ZillowLoginBaseOptions } from '.';
import type { GetZillowWebLoginURLOptions } from '@zillow/auth-core';

// @ts-ignore: local package uses declaration files, ignore for external consumers
import { getZillowWebLoginURL } from '@zillow/auth-core/dist/es/zoam-web-sdk/utils/getZillowWebLoginURL';

export type ZillowLoginUrlOptions = ZillowLoginBaseOptions & GetZillowWebLoginURLOptions;

/**
 * Returns a Zillow login URL string for use in server-side rendering (e.g.
 * `getServerSideProps`).
 *
 * @note does not work well in development due to browser limitations; use `rjs-ext` login instead
 *
 * @example
 * ```typescript
 * export const getServerSideProps = (async (context: GetServerSidePropsContext) => {
 *   const user = await fetchUser();
 *
 *   if (!user) {
 *     return {
 *       redirect: {
 *         destination: zillowLoginUrl({
 *           baseURL: process.env.NEXT_PUBLIC_AUTH_BASE_URL,
 *           entryPoint: 'example-web',
 *           redirectUri: `/example-web${context.resolvedUrl}`
 *         })
 *       }
 *     };
 *   }
 *
 *   return { props: { ... } };
 * }) satisfies GetServerSideProps;
 * ```
 */
export function zillowLoginUrl({ disableForceLogin, ...options }: ZillowLoginUrlOptions): `${string}:${string}` {
  return getZillowWebLoginURL({
    forceLogin: !disableForceLogin,
    ...options,
  }) as `${string}:${string}`;
}
